import LazyLoadImg from "components/LazyLoadImg";
import { RouteName } from "constant/routeNames";
import { useState } from "react";
import { Link } from "react-router-dom";
import AddPlaylistToFav from "../shared/AddPlaylistToFav";
import { Tooltip as ReactTooltip } from "react-tooltip";

function PlaylistCard({
  playlist,
  welcomePage,
  libraryPage,
  userPage,
  discoverPlayist,
  playlistPage,
  searchPage,
}: any) {
  const [active, setActive] = useState(false);
  const [hover, setHover] = useState(false);

  const popupTrigger = () => {
    setActive((val: boolean) => !val);
  };
  return (
    <Link
      to={
        welcomePage === true
          ? RouteName.Home.replace(
              "/",
              RouteName.MusicPlaylistPage.replace(":id", playlist.id),
            )
          : libraryPage === true
            ? RouteName.Playlists.replace(
                "/playlist",
                RouteName.MusicPlaylistPage.replace(":id", playlist.id),
              )
            : userPage === true
              ? RouteName.UserProfile.replace(
                  "/profile/*",
                  RouteName.MusicPlaylistPage.replace(":id", playlist.id),
                )
              : discoverPlayist === true
                ? RouteName.SeeAllDiscoverPlaylistsRoute.replace(
                    "all-playlists",
                    RouteName.MusicPlaylist.replace(":id", playlist.id),
                  )
                : playlistPage === true
                  ? RouteName.Music.replace(
                      "*",
                      RouteName.MusicPlaylist.replace(":id", playlist.id),
                    )
                  : searchPage === true
                    ? RouteName.MusicPlaylistPage.replace(":id", playlist.id)
                    : RouteName.MusicPlaylist.replace(":id", playlist.id)
      }
    >
      <div className="group block w-full cursor-pointer rounded-xl px-2 py-2 text-white shadow-lg transition-all duration-300 ease-out hover:-translate-y-1 hover:bg-slate-800 hover:text-slate-300 hover:shadow-xl">
        <div className="bg-img white-text relative aspect-square w-full overflow-hidden rounded-lg ring-1 ring-white/5 transition-all duration-300 group-hover:ring-2 group-hover:ring-[var(--red)]/40">
          <LazyLoadImg
            imgSrc={playlist?.artwork_url}
            imgAlt={playlist?.title}
            imgHeight={"100%"}
            imgWidth={"100%"}
            wrapperProps={{
              style: {
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                display: "block",
              },
            }}
            className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />

          {/* card inside content */}
          <div className="absolute bottom-0 flex w-full justify-end p-2">
            <div
              className="add-button items-center rounded-full p-1"
              onMouseEnter={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
            >
              <AddPlaylistToFav
                playlist={playlist}
                playlistCard={true}
                hover={hover}
              />
            </div>
          </div>
        </div>
        <div className="relative top-1">
          <div className="my-[4px]">
            <p
              className="text-[15px] font-[600] transition-colors group-hover:text-white"
              data-tooltip-id={`playlist-${playlist?.id}`}
            >
              {playlist?.title?.length > 20
                ? `${playlist?.title.slice(0, 20)}...`
                : playlist?.title}
            </p>

            {playlist?.title?.length > 20 && (
              <div className="text-sm">
                <ReactTooltip
                  id={`playlist-${playlist?.id}`}
                  place="top"
                  content={playlist?.title}
                />
              </div>
            )}

            <p className="mt-[5px] text-[12px] font-[400] text-white/60">
              {playlist?.song_count} Songs
            </p>
          </div>
        </div>
        {active ? (
          <>
            <div
              className="absolute top-0 h-[400px] w-[400px] bg-red-800"
              onClick={popupTrigger}
            ></div>
          </>
        ) : (
          <></>
        )}
      </div>
    </Link>
  );
}

export default PlaylistCard;